
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BillingPlanDtoModel } from './Accounting.Api.Models.BillingPlanDto';
import { Model, ModelProperty } from 'models/Model';


export class CreditWizardRequestModel extends Model<CreditWizardRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'noHandlingFees', type: 'boolean' },
		{ name: 'invoiceNo', type: 'string' },
		{ name: 'brandId', type: 'string' },
		{ name: 'credits', type: 'CreditDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CreditDtoModel }, properties: () => { return CreditDtoModel.classProperties } },
		{ name: 'endAccountingPlans', type: 'EndAccountingPlanDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new EndAccountingPlanDtoModel }, properties: () => { return EndAccountingPlanDtoModel.classProperties } },
		{ name: 'billingPlans', type: 'BillingPlanDtoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new BillingPlanDtoModel }, properties: () => { return BillingPlanDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public companyId?: string;
	public noHandlingFees?: boolean;
	public invoiceNo: string;
	public brandId?: string;
	public credits: CreditDtoModel[];
	public endAccountingPlans: EndAccountingPlanDtoModel[];
	public billingPlans: BillingPlanDtoModel[];
    
	constructor(){
		super();
		this.companyId = undefined;
		this.noHandlingFees = undefined;
		this.invoiceNo = '';
		this.brandId = undefined;
		this.credits = [];
		this.endAccountingPlans = [];
		this.billingPlans = [];
		
	}
	getProperties(){
		return CreditWizardRequestModel.classProperties;
	}
}
export class CreditDtoModel extends Model<CreditDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'invoiceLineNumber', type: 'number' },
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'amount', type: 'number' }
	];
	[key: string]: any;
	
	public invoiceLineNumber: number;
	public accountingPlanId?: string;
	public amount: number;
    
	constructor(){
		super();
		this.invoiceLineNumber = 0;
		this.accountingPlanId = undefined;
		this.amount = 0;
		
	}
	getProperties(){
		return CreditDtoModel.classProperties;
	}
}
export class EndAccountingPlanDtoModel extends Model<EndAccountingPlanDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'endDate', type: 'Date' },
		{ name: 'terminationDate', type: 'Date' },
		{ name: 'terminationReasonId', type: 'string' },
		{ name: 'removeAllUnpostedInvoicePosts', type: 'boolean' },
		{ name: 'createRenewal', type: 'boolean' },
		{ name: 'nextPeriod', type: 'number' }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public endDate?: Date;
	public terminationDate?: Date;
	public terminationReasonId?: string;
	public removeAllUnpostedInvoicePosts?: boolean;
	public createRenewal: boolean;
	public nextPeriod: number;
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.endDate = undefined;
		this.terminationDate = undefined;
		this.terminationReasonId = undefined;
		this.removeAllUnpostedInvoicePosts = undefined;
		this.createRenewal = false;
		this.nextPeriod = 0;
		
	}
	getProperties(){
		return EndAccountingPlanDtoModel.classProperties;
	}
}

